import React from 'react';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export type AiPanelMode = 'ai' | 'notes';

export interface AiPanelToggleProps {
  value: AiPanelMode;
  onChange: (value: AiPanelMode) => void;
}

/**
 * Header switch between PRATUS AI chat and Notes in the V2 AI drawer.
 */
const AiPanelToggle: React.FC<AiPanelToggleProps> = ({ value, onChange }) => (
  <ToggleGroup
    value={[value]}
    onValueChange={(next: unknown[]) => {
      const nextValue = next[0];
      if (nextValue === 'ai' || nextValue === 'notes') onChange(nextValue);
    }}
    variant="outline"
    size="sm"
    spacing={0}
    aria-label="PRATUS AI or Notes"
    data-testid="ai-panel-toggle"
  >
    <ToggleGroupItem value="ai" aria-label="PRATUS AI" className="tw:px-2.5 tw:text-xs">
      PRATUS AI
    </ToggleGroupItem>
    <ToggleGroupItem value="notes" aria-label="Notes" className="tw:px-2.5 tw:text-xs">
      Notes
    </ToggleGroupItem>
  </ToggleGroup>
);

export default AiPanelToggle;
